import { render, staticRenderFns } from "./PublicRGStatusError.vue?vue&type=template&id=db3cc36a&scoped=true&"
import script from "./PublicRGStatusError.vue?vue&type=script&lang=ts&"
export * from "./PublicRGStatusError.vue?vue&type=script&lang=ts&"
import style0 from "./PublicRGStatusError.vue?vue&type=style&index=0&id=db3cc36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3cc36a",
  null
  
)

export default component.exports